import { getPlatformConfig } from "./platform/config";
import { resolveSourceBrandTokens } from "./source-brand-tokens.mjs";

const publisher = getPlatformConfig("driveshare");
const legacy = getPlatformConfig("bac");
export function resolveSourceSnapshot<T>(snapshot: T): T {
  return resolveSourceBrandTokens(snapshot, {
    publisher: { name: publisher.fullName, host: publisher.domain.replace(/^www\./, "") },
    legacy: { name: legacy.name, host: legacy.domain.replace(/^www\./, "") },
  });
}